import { render, staticRenderFns } from "./CardSectionView.vue?vue&type=template&id=67460b94&scoped=true&"
import script from "./CardSectionView.vue?vue&type=script&lang=ts&"
export * from "./CardSectionView.vue?vue&type=script&lang=ts&"
import style0 from "./CardSectionView.vue?vue&type=style&index=0&id=67460b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67460b94",
  null
  
)

export default component.exports